"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureGatesInitialization = void 0;
const react_1 = require("react");
const feature_gate_js_client_1 = __importDefault(require("@atlassian/feature-gate-js-client"));
const utils_1 = require("./utils");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */
const FeatureGatesInitialization = ({ children, enabled = true, identifiers, customAttributes, options, initializingComponent, onReady }) => {
    const [isInitialized, setInitialized] = (0, react_1.useState)(false);
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, react_1.useRef)(options);
    (0, react_1.useEffect)(() => {
        optionsRef.current = options;
    }, [options]);
    (0, react_1.useEffect)(() => {
        if (enabled) {
            setInitialized(false);
            const initPromise = feature_gate_js_client_1.default.initializeCalled()
                ? feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes)
                : feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
            void initPromise
                .catch((err) => (0, utils_1.toError)(err))
                .then((err) => {
                setInitialized(true);
                onReady === null || onReady === void 0 ? void 0 : onReady(err || undefined);
            });
        }
        else {
            setInitialized(true);
            onReady === null || onReady === void 0 ? void 0 : onReady();
        }
    }, [enabled, identifiers, customAttributes]);
    return (0, utils_1.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
exports.FeatureGatesInitialization = FeatureGatesInitialization;
exports.default = exports.FeatureGatesInitialization;
